import {css} from "@panda/css";

import {ITextProps, Text} from "@pg-design/text-module";
import {investmentOffer, numberFormat, propertyOffer} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppSelector} from "../../store/hooks";
import {selectSemanticSearchHasConversation} from "../state/select_semantic_search_has_conversation";
import {getRegionLabel} from "../utils/get_region_label";
import {SemanticSearchBetaBadge} from "./SemanticSearchBetaBadge";

interface IProps extends ITextProps {
    offerCount?: number | null;
}

export function SemanticSearchOffersCountText({offerCount, variant = "headline_4", align = "left", className}: IProps) {
    const propertiesCount = useAppSelector((state) => state.offerList.list.propertiesCount);
    const hasCounts = propertiesCount !== null && propertiesCount !== undefined;
    const selectedRegions = useAppSelector((state) => state.offerList.selectedRegions);

    const {isMobile} = useUserDevice();

    const hasConversation = useAppSelector(selectSemanticSearchHasConversation);

    if (!hasCounts || (isMobile && hasConversation)) {
        return null;
    }

    const regionLabel = getRegionLabel(selectedRegions);
    const hasRegionInFilters = selectedRegions.length > 0;

    const prefix = hasRegionInFilters ? (
        selectedRegions.length === 1 ? (
            <>W miejscowości {regionLabel} mamy obecnie </>
        ) : (
            <>W wybranych regionach ({regionLabel}) mamy obecnie </>
        )
    ) : (
        <>Mamy obecnie </>
    );

    const offersPart = (
        <>
            {numberFormat(propertiesCount)} {propertyOffer.nominative(propertiesCount)}
        </>
    );

    const offerCountPart =
        offerCount != null ? (
            <>
                {" "}
                w {numberFormat(offerCount)} {investmentOffer.locative(offerCount)}.
            </>
        ) : null;

    if (hasConversation) {
        return (
            <div className={headingWithBadge}>
                <Text variant={variant} align={align} className={className} as="p">
                    Asystent AI
                </Text>
                <SemanticSearchBetaBadge />
            </div>
        );
    }

    return (
        <Text variant={variant} align={align} mb={1} className={className} as="p">
            {prefix} {offersPart} {offerCountPart}
        </Text>
    );
}

const headingWithBadge = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1
});
import {css} from "@panda/css";

import {ITextProps, Text} from "@pg-design/text-module";
import {investmentOffer, numberFormat, propertyOffer} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppSelector} from "../../store/hooks";
import {selectSemanticSearchHasConversation} from "../state/select_semantic_search_has_conversation";
import {getRegionLabel} from "../utils/get_region_label";
import {SemanticSearchBetaBadge} from "./SemanticSearchBetaBadge";

interface IProps extends ITextProps {
    offerCount?: number | null;
}

export function SemanticSearchOffersCountText({offerCount, variant = "headline_4", align = "left", className}: IProps) {
    const propertiesCount = useAppSelector((state) => state.offerList.list.propertiesCount);
    const hasCounts = propertiesCount !== null && propertiesCount !== undefined;
    const selectedRegions = useAppSelector((state) => state.offerList.selectedRegions);

    const {isMobile} = useUserDevice();

    const hasConversation = useAppSelector(selectSemanticSearchHasConversation);

    if (!hasCounts || (isMobile && hasConversation)) {
        return null;
    }

    const regionLabel = getRegionLabel(selectedRegions);
    const hasRegionInFilters = selectedRegions.length > 0;

    const prefix = hasRegionInFilters ? (
        selectedRegions.length === 1 ? (
            <>W miejscowości {regionLabel} mamy obecnie </>
        ) : (
            <>W wybranych regionach ({regionLabel}) mamy obecnie </>
        )
    ) : (
        <>Mamy obecnie </>
    );

    const offersPart = (
        <>
            {numberFormat(propertiesCount)} {propertyOffer.nominative(propertiesCount)}
        </>
    );

    const offerCountPart =
        offerCount != null ? (
            <>
                {" "}
                w {numberFormat(offerCount)} {investmentOffer.locative(offerCount)}.
            </>
        ) : null;

    if (hasConversation) {
        return (
            <div className={headingWithBadge}>
                <Text variant={variant} align={align} className={className} as="p">
                    Asystent AI
                </Text>
                <SemanticSearchBetaBadge />
            </div>
        );
    }

    return (
        <Text variant={variant} align={align} mb={1} className={className} as="p">
            {prefix} {offersPart} {offerCountPart}
        </Text>
    );
}

const headingWithBadge = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1
});
